import { useState } from 'react';

export function usePagination() {
  const [limit, setLimit] = useState(50);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);

  const changePage = (page: number) => setPage(page);

  const changeRowsPerPage = (limit: number) => {
    setLimit(limit);
    setPage(0);
  };

  return {
    limit,
    total,
    page,
    changePage,
    changeRowsPerPage,
    setTotal,
  };
}
